const styles = theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  },
  initiatorFlowHeader: {
    fontSize: '32px',
    fontWeight: '500',
    [theme.breakpoints.down('md')]: {
      '&': {
        fontSize: '24px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      '&': {
        display: 'none',
      },
    },
  },
  StepperContainer: {
    padding: '0px',
    // border: '1px solid #CED1D6',
    borderRadius: '0px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    overflowX: ' auto',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    flexWrap: 'nowrap',
  },
  StepperInnerContainer: {
    // background: '#F8F8F8',
    '& .MuiPaper-root': {
      background: 'none',
    },
    borderRadius: '6px',
    '& button': {
      padding: '0px !important',
      margin: '0px',
      fontStyle: 'italic',
      display: 'flex',
      justifyContent: 'start',
    },
    '& div': {
      padding: '8px 8px 8px 0 !important',
      [theme.breakpoints.down('xs')]: {
        marginTop: '12px',
      },
    },
  },
  applicationStepsInitiator: {
    display: 'flex',
    gap: '16px',
  },
  // MuiStepLabeliconContainer: {
  //   // height: '16px',
  //   position: 'relative',
  //   '& svg': {
  //     fontSize: '24px',
  //   },
  // },
  // MuiStepLabelRoot: {
  //   paddingLeft: '20px',
  // },

  StepperHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
    paddingBottom: '17px',
    padding: '16px',
    borderBottom: '1px solid #EBEEF3',
    '& img': {
      cursor: 'pointer',
      width: '20px',
      height: '20px',
    },
  },
  StepperTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#484456',
  },
  ACTIVE: {
    // backgroundColor: theme.palette.secondary.dim,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    '& span': {
      fontWeight: '600 !important',
      color: '#0D2A3A',
    },
    '& text': {
      fontWeight: '600 !important',
      fill: '#0D2A3A !important',
    },
  },
  stepButtonComplete: {
    '& > span > span:first-child > svg': {
      color: '#0D2A3A',
    },
    '& > span > span:last-child > span': {
      color: '#0D2A3A',
    },
  },
  stepperopnerList: {
    padding: '0',
    '& $label': {
      fontSize: '10px',
    },
    '& $labellistActive': {
      color: '#1C999B',
      fontWeight: '600',
    },
    '& button': {
      padding: '7px',
      color: '#342D3D',
      margin: '0',
      justifyContent: 'center',
      '& $activeIcon': {
        color: '#1FCACC',
        '& $completed': {
          fill: '#fff',
        },
      },
      '&:hover': {
        background: '#EFFBFC',
        '& $completed': {
          fill: '#1C999B',
        },
        '& $label': {
          color: '#1C999B',
          fontWeight: '600',
        },
      },
    },
    '& $stepperopnerActive': {
      background: '#EFFBFC',
    },
  },
  listingiconRoot: {
    color: '#F8F8F8',
    display: 'none',
  },
  completed: {
    fill: '#565960',
    fontSize: '14px',
    fontWeight: '400',
  },
  activeIcon: {
    marginTop: '4px',
    fontWeight: '600',
  },
  label: {},
  labellistActive: {},

  '@media (min-width:768px)': {
    stepperopnerList: {
      padding: '0',
      '& span': {
        border: '0',
      },
      '& $label': {
        color: '#342D3D',
        marginBottom: '4px',
        fontSize: '14px',
      },
      '& $labellistActive': {
        color: '#1C999B',
        fontWeight: '600',
      },
      '& button': {
        padding: '12px 20px 12px 0',
        borderRadius: '10px',
        boxSizing: 'border-box',
        color: '#342D3D',
        margin: '0',
        justifyContent: 'flex-start',
        textAlign: 'left',
        '& $activeIcon': {
          color: 'transparent',
          '& $completed': {
            fill: '#1C999B',
          },
        },
        '&:hover': {
          background: '#EFFBFC',
          '& $completed': {
            fill: '#1C999B',
          },
          '& $label': {
            color: '#1C999B',
            fontWeight: '600',
          },
        },
      },
      '& $stepperopnerActive': {
        background: '#EFFBFC',
      },
    },
    listingiconRoot: {
      display: 'none',
      color: 'transparent',
    },
    completed: {
      fill: theme.palette.secondary.main,
      fontSize: '20px',
      fontWeight: '400',
    },
  },

  '@media (max-width:767px)': {
    // StepperContainer: {
    //   border: 'none',
    // },
    // StepperInnerContainer: {
    //   background: 'none',
    // },
    flex1: {
      flex: `1 !important`,
    },
    // RootStep: {
    //   flex: '0 0 25%',
    //   position: 'relative',
    //   '&:not(:last-child)': {
    //     '&:before': {
    //       content: "''",
    //       background: theme.palette.secondary.dim,
    //       display: 'block',
    //       width: '74%',
    //       height: '1px',
    //       right: '-45%',
    //       top: '23%',
    //       // transform: 'translateY(-50%)',
    //       position: 'absolute',
    //       zIndex: '2',
    //     },
    //   },
    // },
    ACTIVE: {
      backgroundColor: '#FFF',
      color: theme.palette.secondary.main,
    },
    StepperHeader: {
      display: 'none',
    },

    stepperopnerList: {
      flexDirection: 'row',
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      '& $label': {
        whiteSpace: 'normal',
      },
    },

    MuiStepLabelRoot: {
      paddingLeft: '0px',
      '& span': {
        fontSize: '16px !important',
        fontWeight: '500 !important',
        color: '#595B61',
      },
    },
    MuiStepLabeliconContainer: {
      // height: '16px',
      position: 'relative',
      paddingRight: '0',
      '& svg': {
        fontSize: '20px',
        color: '#fff !important',
      },
      '& text': {
        fill: '#595B61 !important',
        fontSize: '16px',
      },
    },
  },
});

export default styles;
